import { createContext, useState } from "react";

import React from "react";

const PoliciesContext = createContext();

function PoliciesState(props) {
  const [selectedForShare, setSelectedForShare] = useState([]);
  const addForShare = (item) => {
    setSelectedForShare((prevState) => {
      let newState = [...prevState];
      newState.push(item);
      return newState;
    });
  };
  const addAllToShare = (data) => {
    setSelectedForShare(data);
  };
  const removeFromShare = (item) => {
    setSelectedForShare((prevState) => {
      let newState = [...prevState];
      let updatedState = newState.filter((i) => i._id != item._id);
      return updatedState;
    });
  };
  const removeAllFromShare = () => {
    setSelectedForShare([]);
  };
  return (
    <PoliciesContext.Provider
      value={{
        selectedForShare,
        setSelectedForShare,
        addForShare,
        removeFromShare,
        removeAllFromShare,
        addAllToShare
      }}
    >
      {props.children}
    </PoliciesContext.Provider>
  );
}
export { PoliciesContext, PoliciesState };
